export default {
  dedicated: {
    heading: 'A DEDICATED PARTNER',
    body: 'At RealtyMogul, we sign on to your LLC as an Administrative Member. After closing, we will assign a dedicated asset management professional to be your primary point of contact. Should any decision making items arise over the course of property operations, this asset management professional will also be available to work with you and answer any questions you may have.',
    link: 'LAUNCH YOUR NEXT PROJECT >',
    href: '/sponsor-application',
  },
  overview: {
    title: 'WE KEEP YOUR PROJECTS MOVING FORWARD',
    subtitle: 'RealtyMogul serves as capital markets arm to qualified real estate companies nationwide. Discretionary capital gives us control over the transaction from start to finish. We fund from our own balance sheet and take on the syndication risk by selling the investments to investors. With this efficient and agile structure, we are able to close in as few as 30 days, keeping your projects moving forward.',
  },
};
